export default {"src":"/_next/static/media/hash-to-image-duplicate-error.97519ede.svg","height":620,"width":620,"blurWidth":0,"blurHeight":0};